<template>
    <div class="row creditcard-details">
        <template v-if="cardExists">
            <div class="col d-flex align-items-center">
                <img :src="require(`@assets/img/creditcards/${cardBrands[creditCardInfo.brand]}.svg`)" width="50" :alt="creditCardInfo.brand">
                <span class="ml-2" :class="{ 'deactivated': !membershipStatus.renewal_date }">
                    {{ creditCardInfo.brand }} ending in <strong>{{ creditCardInfo.lastFour }}</strong>
                </span>
            </div>
            <div class="card-date col-auto d-flex align-items-center" :class="{ 'deactivated': !membershipStatus.renewal_date }">
                {{ cardExpirationDate | formatCreditCardExpirationDate }}
            </div>
        </template>
        <div v-else class="col-auto ml-auto">
            <slot name="payment-button" />
        </div>
    </div>
</template>

<script>

import { mapGetters, mapState } from "vuex";
import _isEmpty from "lodash/isEmpty";

export default {
    name: "CreditCardDetails",
    props: {
        creditCardInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            cardBrands: {
                "Visa": "visa",
                "Visa (debit)": "visa",
                "Mastercard": "mastercard",
                "MasterCard": "mastercard",
                "Mastercard (2-series)": "mastercard",
                "Mastercard (debit)": "mastercard",
                "Mastercard (prepaid)": "mastercard",
                "American Express": "american_express",
                "Discover": "discover",
                "Diners Club": "diners_club",
                "JCB": "jcb",
                "UnionPay": "union_pay"
            }
        }
    },
    computed: {
        ...mapState({
            membershipStatus: state => state.UserMembership.nonfictionMembership
        }),
        ...mapGetters({
            isStateReady: "Application/isStateReady"
        }),
        cardExpirationDate() {
            return new Date(this.creditCardInfo.expYear + "/" + this.creditCardInfo.expMonth + "/01");
        },
        cardExists() {
            return !_isEmpty(this.creditCardInfo);
        }
    }
}
</script>

<style lang="scss" scoped>
.creditcard-details {
    span {
        font-size: 15px;
        color: white;
        font-weight: 600;
    }

    strong {
        font-weight: 500;
    }

    .card-date {
        color: white;
        font-size: 15px;
    }
}
</style>
